import { PropTypes } from 'react';

export default PropTypes.shape({
  user_id: PropTypes.number,
  ip: PropTypes.string,
  favorites: PropTypes.array,
  units: PropTypes.string,
  type: PropTypes.string,
});



// WEBPACK FOOTER //
// ./src/propTypes/legacyUserSettings.js